module.exports = ".audiobook {\n    padding: 10px 10px 10px 10px;\n}"